// extracted by mini-css-extract-plugin
export default {"ResumeContainer":"uUI8s","ResumeContainer__container":"lai0v"};